/* Better Turns POS System
 * Copyright (c) 2024 Better Turns LLC
 * All rights reserved.
 *
 * Author: Gabe Mohacsi
 * Description: This page is main driver of the resource section.
 * License: Proprietary - Redistribution, modification, or use without
 * explicit permission from Better Turns LLC is prohibited.
 */
// src/pages/ResourceCenter.js
import React, { useState } from 'react';
import { categories } from '../data/resources';
import ResourceCard from '../components/ResourceCard';

const ResourceCenter = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedTeasers, setExpandedTeasers] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  const toggleCategory = (index) => {
    setExpandedCategory(index === expandedCategory ? null : index);
  };

  const toggleTeaser = (resId) => {
    setExpandedTeasers((prev) => ({
      ...prev,
      [resId]: !prev[resId],
    }));
  };

  // 1. Filter logic: for each category, only keep resources matching searchTerm in title or teaser
  const filteredCategories = categories.map((cat) => {
    const filteredResources = cat.resources.filter(
      (r) =>
        r.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        r.teaser.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return { ...cat, resources: filteredResources };
  });

  return (
    <section className="section-wrapper bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="section-title">Resource Center</h2>
        <p className="section-subtext mb-6">
          Explore topics on Tier 1 strategy, vendor promotions, planograms, and
          more.
        </p>

        {/* 2. Search bar */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search by title or teaser..."
            className="border border-gray-300 px-4 py-2 rounded w-full md:w-1/2"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* 3. Accordion for categories */}
        {filteredCategories.map((cat, i) => (
          <div
            key={i}
            className="mb-4 border-b border-cool-gray pb-2"
          >
            {/* Accordion header */}
            <button
              onClick={() => toggleCategory(i)}
              className="w-full text-left font-semibold text-lg py-2 hover:underline"
            >
              {cat.category}
            </button>

            {/* If expanded, show resources in this category */}
            {expandedCategory === i && (
              <div className="mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {cat.resources.map((res) => (
                  <ResourceCard
                    key={res.id}
                    resource={res}
                    isTeaserOpen={!!expandedTeasers[res.id]}
                    onToggleTeaser={() => toggleTeaser(res.id)}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ResourceCenter;
